import React from 'react';
import { FaWhatsapp, FaFacebook, FaInstagram, FaRegCopy, FaTimes } from 'react-icons/fa';
import { toast } from "react-toastify";

const ShareModal = ({ isOpen, onClose, shareText }) => {
  if (!isOpen) return null;

  const encodedText = encodeURIComponent(shareText);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareText).then(() => {
        toast.success("Content copied to clipboard!");
        onClose();
    }).catch(err => {
        console.error('Failed to copy: ', err);
        // Fallback for older browsers
        const tempTextArea = document.createElement("textarea");
        tempTextArea.value = shareText;
        document.body.appendChild(tempTextArea);
        tempTextArea.select();
        document.execCommand("copy");
        document.body.removeChild(tempTextArea);
        toast.success("Content copied to clipboard!");
        onClose();
    });
  };

  const handleWhatsApp = () => {
    const url = `https://api.whatsapp.com/send?text=${encodedText}`;
    window.open(url, '_blank');
    onClose();
  };

  const handleFacebook = () => {
     // Facebook sharer
     const currentUrl = window.location.href;
     const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}&quote=${encodedText}`;
     window.open(url, '_blank');
     onClose();
  };
  
  const handleInstagram = () => {
     // Instagram (redirect to home as requested to navigate to application)
     window.open('https://www.instagram.com/', '_blank');
     onClose();
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50" onClick={onClose}>
      <div className="bg-white rounded-lg shadow-xl w-full max-w-sm mx-4 overflow-hidden relative" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b">
           <h3 className="text-lg font-semibold text-gray-800">Share</h3>
           <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
             <FaTimes size={20} />
           </button>
        </div>
        
        <div className="p-6">
          <p className="text-sm text-gray-600 mb-6 font-medium">Share using</p>
          <div className="grid grid-cols-4 gap-4">
             <button onClick={handleWhatsApp} className="flex flex-col items-center gap-2 group w-full">
               <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                 <FaWhatsapp className="text-green-600 text-2xl" />
               </div>
               <span className="text-xs text-gray-700 text-center">WhatsApp</span>
             </button>

             <button onClick={handleFacebook} className="flex flex-col items-center gap-2 group w-full">
               <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                 <FaFacebook className="text-blue-600 text-2xl" />
               </div>
               <span className="text-xs text-gray-700 text-center">Facebook</span>
             </button>

             <button onClick={handleInstagram} className="flex flex-col items-center gap-2 group w-full">
               <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center group-hover:bg-pink-200 transition-colors">
                 <FaInstagram className="text-pink-600 text-2xl" />
               </div>
               <span className="text-xs text-gray-700 text-center">Instagram</span>
             </button>

             <button onClick={handleCopy} className="flex flex-col items-center gap-2 group w-full">
               <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center group-hover:bg-gray-200 transition-colors">
                 <FaRegCopy className="text-gray-600 text-2xl" />
               </div>
               <span className="text-xs text-gray-700 text-center">Copy</span>
             </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
